import React from 'react';
import bgImage from '../../assets/bg.jpg';
import ContactForm from '../../components/ContactForm/ContactForm.js';

import './contact.css';

const Contact = () => {
  return (
    <>
      <main>
        <img src={bgImage} alt="bgImage" className="bgImage" />
        <div className="contactFormContainer">
          <ContactForm />
        </div>
      </main>
    </>
  );
};

export default Contact;
